import React from 'react'
import styles from './styles/error.module.css';
import Navbar from '../component/navbar/Navbar';
function ErrorPage() {
  return (
    <>
      <div>
        <Navbar />
      </div>
      <div className={styles.errorContainer} >
        <img className={styles.errorImg} src={require('../assets/images/error404.gif')} alt="loading..." />
      </div>
    </>
  )
}

export default ErrorPage;